<template>
  <transition name="toast">
    <div
      v-if="visible"
      class="min-w-[300px] max-w-[350px] p-4 rounded-xl shadow-md border bg-card flex flex-col gap-4"
      :class="typeClasses"
    >
      <div class="flex justify-between flex-shrink-0">
        <div
          class="w-9 h-9 rounded-full flex items-center justify-center"
          :class="iconBg"
        >
          <component :is="iconComponent" class="w-4 h-4" />
        </div>
        <Button variant="ghost" class="close" type="button" @click="close">
          <svg-icon name="huge-close" class="w-5 h-5" />
        </Button>
      </div>

      <div class="flex-1 flex flex-col gap-1">
        <div class="text-sm font-semibold text-foreground">
          {{ title }}
        </div>
        <div class="text-sm text-muted-foreground">
          {{ description }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { CircleCheck, CircleClose } from "@element-plus/icons-vue";
import Button from "@/shared/ui/button/Button.vue";

export default {
  name: "BaseToast",
  components: { Button },
  props: {
    type: {
      type: String,
      default: "success",
    },
    title: String,
    description: String,
    duration: {
      type: Number,
      default: 60 * 1000,
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    iconComponent() {
      return this.type === "success" ? CircleCheck : CircleClose;
    },
    iconBg() {
      return this.type === "success"
        ? "bg-green-100 text-green-600"
        : "bg-red-100 text-red-600";
    },
    typeClasses() {
      return this.type === "success"
        ? "border-solid border-border"
        : "border-solid border-border";
    },
  },
  mounted() {
    if (this.duration) {
      setTimeout(() => {
        this.close();
      }, this.duration);
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit("close");
    },
  },
};
</script>

<style>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.close {
  @apply w-8 h-8 flex items-center justify-center rounded-full;
  @apply text-muted-foreground hover:bg-muted;
}
</style>
